import { render } from "./comment.vue?vue&type=template&id=f74193a0&scoped=true&ts=true"
import script from "./comment.vue?vue&type=script&lang=ts"
export * from "./comment.vue?vue&type=script&lang=ts"

import "./comment.vue?vue&type=style&index=0&id=f74193a0&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f74193a0"]])

export default __exports__